import React from "react";
import { Modal, Progress, Button, Flex, Typography } from "antd";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface UploadProgressModalProps {
  isVisible: boolean;
  progress: number;
  isComplete: boolean;
  isError: boolean;
  fileName?: string;
  onClose: () => void;
}

export default function UploadProgressModal({
  isVisible,
  progress,
  isComplete,
  isError,
  fileName,
  onClose,
}: UploadProgressModalProps) {
  const getStatus = () => {
    if (isError) return "exception";
    if (isComplete) return "success";
    return "active";
  };

  const getTitle = () => {
    if (isError) return "Upload Failed";
    if (isComplete) return "Upload Complete";
    return "Uploading...";
  };

  return (
    <Modal
      title={getTitle()}
      open={isVisible}
      footer={null}
      closable={false}
      centered
      width={400}
    >
      <Flex vertical gap={16} style={{ padding: "16px 0" }}>
        {fileName && (
          <Text type="secondary">
            File: {fileName}
          </Text>
        )}
        
        <Progress
          percent={Math.round(progress)}
          status={getStatus()}
          strokeColor={isError ? "#ff4d4f" : undefined}
        />
        
        {isComplete && (
          <Flex align="center" gap={8}>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text type="success">File uploaded successfully!</Text>
          </Flex>
        )}
        
        {isError && (
          <Text type="danger">
            Failed to upload file. Please try again.
          </Text>
        )}
        
        {(isComplete || isError) && (
          <Flex justify="flex-end">
            <Button 
              type="primary" 
              icon={<CloseOutlined />}
              onClick={onClose}
            >
              Close
            </Button>
          </Flex>
        )}
      </Flex>
    </Modal>
  );
}
